import axios from 'axios';

// Comon API
export const getLanguages = async () => {
  const query = await axios.post('/Language/GetAll');
  const data = query.data.data;
  const isDone = query.data.isDone;
  return { data, isDone };
};

// GalleryAlbumApi
export const getGalleryAlbum = async (e) => {
  const query = await axios.post('/GlAlbumItem/GetAllBy', e.queryKey[1]);
  const data = query.data.data;
  const isDone = query.data.isDone;
  const paginationResult = query.data.paginationResult;
  return { data, isDone, paginationResult };
};

export const addGalleryAlbumItem = async (e) => {
  const { data } = await axios.post('/GlAlbumItem/Add', e);
  return data;
};

export const addGalleryAlbumItemList = async (e) => {
  const { data } = await axios.post('/GlAlbumItem/AddList', e);
  return data;
};

export const editGalleryAlbumItem = async (e) => {
  const { data } = await axios.post('/GlAlbumItem/Edit', e);
  return data;
};

export const deleteGalleryAlbumItem = async (id) => {
  const mutation = await axios.post(`/GlAlbumItem/Delete`, { id });
  const data = mutation.data.data;
  const isDone = mutation.data.isDone;
  return { data, isDone };
};
